const UNAVAILABLE = JSON.stringify({ available: false });

const MyFitnessPalDiary = (app) => {
  app.get("/myfitnesspal-diary", async ({ req, res, api }) => {
    res.headers = res.headers || {};
    res.headers["Content-Type"] = "application/json; charset=utf-8";
    res.headers["Cache-Control"] = "no-store";

    const { athleteId } = req.query || {};
    try {
      const response = await api("myfitnesspal-diary", {
        query: { athleteId },
      });
      const data = await response.json();
      res.status = 200;
      res.body = JSON.stringify(data);
    } catch (e) {
      res.status = e?.name === "HttpError" && e.code >= 400 ? e.code : 502;
      res.body = UNAVAILABLE;
    }
  });
};

export default MyFitnessPalDiary;
